module.exports = __webpack_public_path__ + "img/tab-1.c676c255.svg";